import { STATUS_META } from "./utils/salesInvoicesFormat";
import type {SalesInvoiceDisplayStatus} from "../../../../../generated/enums.ts";

export function SalesInvoiceStatusPill({ status }: { status: SalesInvoiceDisplayStatus }) {
    const meta = STATUS_META[status];
    return (
        <span
            className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${meta.pillClasses}`}
        >
            <span className={`h-1.5 w-1.5 rounded-full ${meta.dotClasses}`} />
            {meta.label}
        </span>
    );
}
